export default __webpack_public_path__ + "static/media/hi_gray.be6d5936.svg";